
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': '資料來源',
	'dataSourceId': 'ID',
	'dataSourceType': '類型',
	'dataSourceName': '名稱',
	'dataSourcePath': '路徑',
	'showInfoForAll': '顯示所有視覺化的持續時間',
	'hideInfoForAll': '隱藏所有視覺化的持續時間',
	'showPerformanceDetails': '重新執行所有小組件以包括效能詳細資料',
	'slotMappingField': '槽對映',
	'slotDataMapping': '對映',
	'slotID': 'ID',
	'slotCaption': '標題',
	'slotMandatory': '必要欄位',
	'slotIsMandatory': '是',
	'slotIsNotMandatory': '否',
	'infoNotAvailable': '無法使用',
	'performanceSection': '效能',
	'durationField': '持續時間',
	'singleQueryTime': '伺服器查詢（毫秒）',
	'multipleQueryTime': '伺服器查詢 %{name}（毫秒）',
	'liveWidgetTotalTime': '總計（毫秒）',
	'renderTimeNotAvailable': '無法使用',
	'renderInProgress': '（進行中）',
	'interactToTriggerQuery': '與小組件進行互動以觸發查詢',
	'fetchQuery': '提取查詢',
	'showSQLMDX': '顯示 SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': '查詢資訊',
	'queryInfoNotAvailable': '查詢資訊無法使用',
	'query': '查詢',
	'copy': '複製',
	'close': '關閉'
});
